/* eslint-disable @typescript-eslint/no-explicit-any */
// LinkMention.ts
import Mention from '@tiptap/extension-mention'

export const LinkMention = Mention.extend({
  name: 'linkMention',
  priority: 1001,
  deleteTriggerWithBackspace: true,
  addOptions() {
    return {
      removePrefixOnDelete: true,
      prefixChar: '@',
      ...this.parent?.(),
      // customize which links to convert, e.g. only internal links:
      hrefPredicate: () => true,
      // customize mention attrs produced from a link
      makeAttrs: (href: string, label: string) => ({
        id: href,
        label,
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
        class: 'link mention-link',
      }),
    }
  },
  addCommands() {
    return {
      ...this.parent?.(),
      insertLinkMention:
        (attrs: { class: any }) =>
        ({ chain }: { chain: any }) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: {
                ...attrs,
                class: `${attrs.class ?? 'link mention-link'} special-inserted`, // <-- extra class on insert
              },
            })
            .run()
        },
    }
  },
  renderText({ node }) {
    return `${node.attrs.label}` // no @ prefix for links
  },

  renderHTML({ node, HTMLAttributes }) {
    const { id, label, href } = node.attrs
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-href': href ?? id,
        'data-type': 'linkMention',
        class: 'mention mention-link',
        contenteditable: 'false',
      },
      `${label ?? id}`,
    ]
  },
})
